export default __webpack_public_path__ + "static/Holzrückung-90811a6335b4f8732912855b4afe58f6.jpg";